export default process.env.VUE_APP_RESERVATIONS_ENABLED === 'true' ? [{
  path: 'reservations',
  name: 'reservations',
  component: () => import('@/views/reservations/Reservations.vue'),
  meta: { requiresAuth: true, roles: ['operator', 'admin'] },
}] : [];
